// extracted by mini-css-extract-plugin
export var actionButton = "_k4-t";
export var buttonContainer = "_k4-0";
export var buttonContainer2 = "_k4-1";
export var buttonSection = "_k4-2";
export var details = "_k4-3";
export var dropdownItem = "_k4-5";
export var dropdownItemsContainer = "_k4-4";
export var fileInput = "_k4-r";
export var headerButton = "_k4-6";
export var icon = "_k4-7";
export var input = "_k4-8";
export var macroListItem = "_k4-9";
export var mainContent = "_k4-a";
export var microText = "_k4-b";
export var modal = "_k4-w";
export var optionsButton = "_k4-c";
export var paperclip = "_k4-s";
export var pillContent = "_k4-d";
export var preview = "_k4-e";
export var preview2 = "_k4-f";
export var quillEditor = "_k4-q";
export var selectedMacro = "_k4-g";
export var sidebar = "_k4-h";
export var sidebarHeader = "_k4-j";
export var sidebarList = "_k4-i";
export var sidebarListItem = "_k4-k";
export var sidebarSearch = "_k4-l";
export var snoozeDurationWrapper = "_k4-v";
export var statusPillContainer = "_k4-m";
export var tagsContainer = "_k4-n";
export var unselectedMacro = "_k4-o";
export var variable = "_k4-u";
export var wrapper = "_k4-p";